import React, { Fragment, useEffect } from 'react';
import { IntlProvider, FormattedNumber, FormattedDate } from 'react-intl';
import './readerReceipt.css';
import { MatxLoading } from '../../../app/components';
import useCredio from '../../../app/hooks/useCredio';


const Receipt = ({ data, onCLick }) => {

  var { loadUserData, userData, getEachUser, } = useCredio();


  return (
    <>
      <IntlProvider locale="en" defaultLocale="en">
        <div className="modal-content">
          <div className="receipt">
            <div className="header">
              <img src="https://media.licdn.com/dms/image/C4D0BAQEgRMjOAbjIFg/company-logo_200_200/0/1624933162683?e=2147483647&v=beta&t=Txh0IHnMoynKHn2QxqbK5mA8VGcwG2Pgl80cRD94SOM"
                alt="Company Logo" className="company-logo" />
              <span id="close" class="close" onClick={onCLick}>
                &times;
              </span>
              <h1>CREDIO READER Receipt</h1>
              <p>Date: <span id="date">{
                <FormattedDate value={data.createdAt}
                formatMatcher=''
                />
              }</span></p>
            </div>



            <div className="transaction-details">
              <p>Card Type: <span id="status">{data.from}</span></p>
              <p>RRN: <span id="rrn">{data.referenceData.rrn}</span></p>
              <p>Masked PAN: <span id="maskPAN">{data.referenceData.maskedPan}</span></p>
              <p>Terminal ID: <span id="maskPAN">{data.referenceData.terminalId}</span></p>
            </div>
            <div className="separator"></div>

            <div className="transaction-details">


              <p>STAN: <span id="stan">{data.referenceData.STAN}</span></p>
              <p>AUTH CODE: <span id="maskPAN">{data.referenceData.authCode}</span></p>
              <p>Message: <span id="status">{data.referenceData.messageReason}</span></p>
            </div>

            <div className="separator"></div>

            <div className="total">
              <p>Total: <span id="totalAmount">
                <FormattedNumber value={data.amount} style="currency" currency="NGN" />
              </span></p>
            </div>

            <div className="separator"></div>

            <div className="footer">
              <p>Thank you for using Credio!</p>
            </div>
          </div>
        </div>
      </IntlProvider>
    </>

  );

};

export default Receipt;